import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
    container: {
        height: '100%',
        width: '100%',
        overflow: 'scroll',
        alignItems: 'stretch'
    },
    section: {
        paddingTop: 10,
        paddingVertical: 8,
    },
    titleLarge: {
        fontSize: 20,
        fontWeight: '600',
        marginBottom: 16,
        color: '#1a1a1a',
    },
    titleMedium: {
        fontSize: 16,
        fontWeight: '600',
        marginBottom: 8,
        color: '#2d2d2d',
    },
    bodyText: {
        fontSize: 14,
        lineHeight: 20,
        color: '#4a4a4a',
        marginBottom: 6,
    },
    emphasized: {
        fontWeight: '500',
        color: '#2d2d2d',
    },
});
